
import { Injectable } from '@angular/core';
import { HttpDataService } from '../http/http-data.service';

export interface IStoredReportAggregate {
  showSum?:boolean;
  showCount?:boolean;
  showAverage?:boolean;
  showMinimum?:boolean;
  showMaximum?:boolean;
}

export interface IStoredReport extends IStoredReportAggregate {
  id?:number;
  code?:string;
  description?:string;
  orderBy?:string;
  columns?:IStoredReportColumn[];
  ga1AddUrl?:string;
  browselistCode?:string;
  editDisabled?:boolean; // disabled edit
  category?:string;
  sequence?:number;
  sharedStoredReport?:boolean;
}

export interface IStoredReportColumn {
  name:string;
  filterValue?:string;
  filterValue2?:string;
  showInSearch?:boolean;
  searchSequence?:number;
  showInList?:boolean;
  listSequence?:number;
  groupingSequence?:number;
  aggregateOn?:string;
  pivotSequence?:number;
}

@Injectable()
export class StoredReportDataService {
  constructor(
    private httpDataService: HttpDataService
  ) {
  }

  public loadStoredReports(reportId:number | string):Promise<IStoredReport[]> {
    return this.httpDataService.doGET(
      `rest/reports/${reportId}/stored`,
      undefined,
      undefined,
      'Error loading saved reports'
    );
  }

  public loadStoredReport(reportId:number | string, storedReport:string|number):Promise<IStoredReport> {
    return this.httpDataService.doGET(
      `rest/reports/${reportId}/stored/${storedReport}`,
      undefined,
      undefined,
      'Error loading stored report'
    );
  }

  public saveNewStoredReport(reportId:number, data:IStoredReport):Promise<IStoredReport> {
    const url:string = `rest/reports/${reportId}/stored`;
    return this.httpDataService.doPOST(
      url,
      undefined,
      data,
      'Saving new report',
      'Error saving new report'
    );
  }

  public saveExistingStoredReport(reportId:number, storedReportId:number, data:IStoredReport):Promise<IStoredReport> {
    const url:string = `rest/reports/${reportId}/stored/${storedReportId}`;
    return this.httpDataService.doPUT(
      url,
      undefined,
      data,
      'Saving report',
      'Error saving report'
    );
  }

  public deleteStoredReport(reportId:number, storedReportId:number):Promise<any> { //really it returns void
    const url:string = `rest/reports/${reportId}/stored/${storedReportId}`;
    return this.httpDataService.doDELETE(
      url,
      undefined,
      'Deleting report',
      'Error deleting report'
    );
  }

}